import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Container } from "@bw/bits"
import { SideMenu } from "@bw/partials"
import { useTranslation } from "react-i18next"
import { breakpoints } from "../../../theme"
import useWindowWidth from "../../../hooks/useWindowWidth"
import Sticky from "react-stickynode"
import * as Icons from "@bw/icons"
import { motion } from "framer-motion"

const Wrapper = styled.div`
  display: grid;
  flex-direction: column;
  gap: 25px;
  margin-top: 50px;

  @media (min-width: ${breakpoints.medium}px) {
    grid-template-columns: 202px auto;
  }

  .container {
    padding: 0;
  }

  .section:first-child {
    margin-top: 0;
  }
`

const Rubrics = styled.button`
  background: none;
  padding: none;
  border: none;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  gap: 8px;
  align-items: center;
  line-height: 172.5%;
  cursor: pointer;
  transform: translateX(-9px);
  color: var(--text-color);

  > div {
    transform: rotate(90deg);
  }
`

const variants = {
  open: { opacity: 1, display: "flex", flexDirection: "column" },
  closed: { opacity: 0, transitionEnd: { display: "none" } },
}

const SidebarLayout = ({ sidemenu, children }) => {
  const { t } = useTranslation()
  const size = useWindowWidth()
  const [show, setShow] = React.useState(true)
  const listRef = React.useRef(null)
  React.useEffect(() => {
    setShow(size >= breakpoints.medium)
  }, [size])

  return (
    <Container size="xlarge">
      <Wrapper>
        {sidemenu ? (
          <Sticky
            enabled={size >= breakpoints.medium}
            top={150}
            bottomBoundary="#bottomSticky"
          >
            <Rubrics onClick={() => setShow(!show)}>
              <div>
                <Icons.ArrowSidemenu fillColor="var(--text-color)" />
              </div>
              {t("sidemenu.title")}
            </Rubrics>
            <motion.div
              animate={show ? "open" : "closed"}
              ref={listRef}
              variants={variants}
              transition={{ duration: 0.6 }}
              initial={size >= breakpoints.medium ? true : false}
            >
              <SideMenu tabs={sidemenu} />
            </motion.div>
          </Sticky>
        ) : (
          <div />
        )}
        <div>{children}</div>
      </Wrapper>
      <div id="bottomSticky" />
    </Container>
  )
}

SidebarLayout.propTypes = {
  sidemenu: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      title: PropTypes.string,
    })
  ),
}

export { SidebarLayout }
